import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-pill-mailto',
    templateUrl: './pill-mailto.component.html',
    styleUrls: ['./pill-mailto.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PillMailtoComponent {
    @Input() mailtoEmail: string;
}
